import deepFreeze from 'deep-freeze'
import { DashboardTypes } from 'features/Codes'
import { EtcColumns, GeneralColumns, MetricColumns } from '../../../Columns'

export const getSerializablePreset = preset => ({
  ...preset,
  columns: [
    ...preset.columns.map(({ tooltip: omit, ...column }) => ({
      ...column,
    })),
  ],
})

export const GeneralPresetColumns = deepFreeze({
  [DashboardTypes.CAMPAIGN]: [
    GeneralColumns.operationStatus,
    GeneralColumns.campaignType,
    GeneralColumns.bizChannel,
    GeneralColumns.dailyBudget,
    GeneralColumns.impressionDate,
  ],
  [DashboardTypes.AD_GROUP]: [
    GeneralColumns.operationStatus,
    GeneralColumns.campaignType,
    GeneralColumns.maxBiddingAmount,
    GeneralColumns.dailyBudget,
    GeneralColumns.impressionDate,
    GeneralColumns.impressionWeeklySchedule,
    GeneralColumns.contentMatchingmaxBiddingAmount,
    GeneralColumns.mediaType,
    GeneralColumns.userDevice,
    GeneralColumns.keywordEx,
    GeneralColumns.segmentKeyword,
    GeneralColumns.campaign,
  ],
  [DashboardTypes.KEYWORD]: [
    GeneralColumns.operationStatus,
    GeneralColumns.campaignType,
    GeneralColumns.reviewStatus,
    GeneralColumns.keywordBiddingAmount,
    GeneralColumns.score,
    GeneralColumns.exposureStatus,
    GeneralColumns.landingUrlSetting,
    GeneralColumns.landingUrl,
    GeneralColumns.campaign,
    GeneralColumns.adGroup,
  ],
  [DashboardTypes.CREATIVE]: [
    GeneralColumns.operationStatus,
    GeneralColumns.campaignType,
    GeneralColumns.reviewStatus,
    GeneralColumns.campaign,
    GeneralColumns.adGroup,
  ],
})
export const getGeneralPresets = domainType => ({
  name: 'GENERAL',
  displayName: '일반 정보',
  tiaraActionName: '열:정보_일반정보_클릭',
  columns: GeneralPresetColumns[domainType],
})

export const MetricPresets = deepFreeze({
  BASIC: {
    name: 'BASIC',
    displayName: '기본 지표',
    tiaraActionName: '열:실적지표_기본지표_클릭',
    columns: [
      MetricColumns.viewableImpression,
      MetricColumns.click,
      MetricColumns.ctr,
      MetricColumns.spending,
    ],
  },
  ADDITIONAL: {
    name: 'ADDITIONAL',
    displayName: '추가 지표',
    tiaraActionName: '열:실적지표_추가지표_클릭',
    columns: [
      MetricColumns.renderedImpression,
      MetricColumns.ppc,
      MetricColumns.rank,
      MetricColumns.costPerImp,
    ],
  },
  PIXEL_AND_SDK: {
    name: 'PIXEL_AND_SDK',
    displayName: '픽셀&SDK 전환 지표',
    tiaraActionName: '열:전환지표_픽셀&SDK전환지표_클릭',
    columns: [
      MetricColumns.convAppInstall7d,
      MetricColumns.convCmptReg7d,
      MetricColumns.convViewCart7d,
      MetricColumns.convPurchase7d,
      MetricColumns.convPurchaseP7d,
      MetricColumns.convParticipation7d,
      MetricColumns.convSignup7d,
      MetricColumns.convAppInstall1d,
      MetricColumns.convCmptReg1d,
      MetricColumns.convViewCart1d,
      MetricColumns.convPurchase1d,
      MetricColumns.convPurchaseP1d,
      MetricColumns.convParticipation1d,
      MetricColumns.convSignup1d,
    ],
  },
  TALK_CHANNEL: {
    name: 'TALK_CHANNEL',
    displayName: '카카오 친구 지표',
    tiaraActionName: '열:전환지표_카카오_친구_지표_클릭',
    columns: [
      MetricColumns.convKfPfAdd7d,
      MetricColumns.costPerConvKfPfAdd7d,
      MetricColumns.convKfPfAdd7dRate,
      MetricColumns.convKfPfAdd1d,
      MetricColumns.costPerConvKfPfAdd1d,
      MetricColumns.convKfPfAdd1dRate,
    ],
  },
})

export const CustomPreset = {
  name: 'CUSTOM',
  displayName: '맞춤 설정',
  columns: [],
}

export const EtcPresetColumns = deepFreeze({
  [DashboardTypes.CAMPAIGN]: [
    EtcColumns.campaignId,
    EtcColumns.createdDate,
    EtcColumns.updatedDate,
  ],
  [DashboardTypes.AD_GROUP]: [
    EtcColumns.adGroupId,
    EtcColumns.createdDate,
    EtcColumns.updatedDate,
  ],
  [DashboardTypes.KEYWORD]: [
    EtcColumns.keywordId,
    EtcColumns.createdDate,
    EtcColumns.updatedDate,
  ],
  [DashboardTypes.CREATIVE]: [
    EtcColumns.creativeLinkId,
    EtcColumns.creativeId,
    EtcColumns.createdDate,
  ],
})
export const getEtcPresets = domainType => ({
  name: 'ETC',
  displayName: '기타',
  tiaraActionName: '열:기타_클릭',
  columns: EtcPresetColumns[domainType],
})

export const DomainDefaultColumns = deepFreeze({
  [DashboardTypes.CAMPAIGN]: [
    GeneralColumns.operationStatus.name,
    GeneralColumns.campaignType.name,
    GeneralColumns.bizChannel.name,
    GeneralColumns.dailyBudget.name,
    MetricColumns.viewableImpression.name,
    MetricColumns.click.name,
    MetricColumns.ctr.name,
    MetricColumns.spending.name,
  ],
  [DashboardTypes.AD_GROUP]: [
    GeneralColumns.operationStatus.name,
    GeneralColumns.campaignType.name,
    GeneralColumns.maxBiddingAmount.name,
    GeneralColumns.dailyBudget.name,
    GeneralColumns.impressionDate.name,
    MetricColumns.viewableImpression.name,
    MetricColumns.click.name,
    MetricColumns.ctr.name,
    MetricColumns.spending.name,
  ],
  [DashboardTypes.KEYWORD]: [
    GeneralColumns.operationStatus.name,
    GeneralColumns.campaignType.name,
    GeneralColumns.reviewStatus.name,
    GeneralColumns.keywordBiddingAmount.name,
    GeneralColumns.score.name,
    GeneralColumns.exposureStatus.name,
    GeneralColumns.landingUrlSetting.name,
    MetricColumns.viewableImpression.name,
    MetricColumns.click.name,
    MetricColumns.ctr.name,
    MetricColumns.spending.name,
  ],
  [DashboardTypes.CREATIVE]: [
    GeneralColumns.operationStatus.name,
    GeneralColumns.campaignType.name,
    GeneralColumns.reviewStatus.name,
    MetricColumns.viewableImpression.name,
    MetricColumns.click.name,
    MetricColumns.ctr.name,
    MetricColumns.spending.name,
  ],
})

export const PresetOrders = [
  'GENERAL',
  'BASIC',
  'ADDITIONAL',
  'PIXEL_AND_SDK',
  'TALK_CHANNEL',
  'ETC',
]
